import {Injectable} from "@angular/core";
import {filter, switchMap, take} from "rxjs/operators";
import {catchError, Observable, of} from "rxjs";
import {WidgetSettingsService} from "./widget-settings.service";
import {CookieService} from "ngx-cookie-service";
import {MediaService} from "fello-common";
import {ActivatedRoute} from "@angular/router";

const TRACKING_COOKIE_NAME = "_wt"; // Widget tracking
@Injectable()
export class WidgetTrackingService {
  constructor(
    private mediaApiService: MediaService,
    private cookiesService: CookieService,
    private publicWidgetsService: WidgetSettingsService,
    private activatedRoute: ActivatedRoute
  ) {}

  trackView(): Observable<unknown> {
    // waits for settings to be present before making the api call.
    return this.publicWidgetsService.settings$.pipe(
      filter(settings => !!settings),
      take(1),
      switchMap(settings => {
        if (!settings) {
          return of();
        }
        const widgetId = this.activatedRoute.snapshot.params.widgetId;
        const overridden = this._setTrackingToken(widgetId, settings._t);
        if (!overridden) {
          return this.mediaApiService.trackView(settings._t).pipe(catchError(() => of())); // in case of track api failure, we dont want to stop observable chains.
        }
        return of();
      })
    );
  }

  private _setTrackingToken(widgetId: string, token: string): boolean {
    const cookieName = widgetId + TRACKING_COOKIE_NAME;
    const existingToken = this.cookiesService.get(cookieName);
    const overridden = !!existingToken; // Check if an old token already exists
    const expiryDate = new Date(Date.now() + 60 * 1000); // add 60 sec to now.
    this.cookiesService.set(cookieName, token, expiryDate, "/", undefined, true, "None");
    return overridden;
  }
}
